import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useReservationsStore = defineStore('reservations', () => {
  const pendingCount = ref(0)
  const loading = ref(false)
  const lastFetched = ref(null)

  const fetchPendingCount = async (businessId) => {
    if (!businessId) return

    loading.value = true
    try {
      const { data, error } = await useApi(`/api/reservations/pending-count?businessId=${businessId}`)

      if (!error.value && data.value?.data) {
        pendingCount.value = data.value.data.pendingCount || 0
        lastFetched.value = Date.now()
      }
    } catch (err) {
      console.error('Failed to fetch pending reservations count:', err)
    } finally {
      loading.value = false
    }
  }

  const incrementPendingCount = () => {
    pendingCount.value++
  }

  const decrementPendingCount = () => {
    if (pendingCount.value > 0) {
      pendingCount.value--
    }
  }

  const resetPendingCount = () => {
    pendingCount.value = 0
  }

  return {
    pendingCount,
    loading,
    lastFetched,
    fetchPendingCount,
    incrementPendingCount,
    decrementPendingCount,
    resetPendingCount,
  }
})
